import { render, staticRenderFns } from "./cTextHighlight.vue?vue&type=template&id=83586410&scoped=true"
import script from "./cTextHighlight.vue?vue&type=script&lang=js"
export * from "./cTextHighlight.vue?vue&type=script&lang=js"
import style0 from "./cTextHighlight.vue?vue&type=style&index=0&id=83586410&prod&scoped=true&lang=scss"
import style1 from "./cTextHighlight.vue?vue&type=style&index=1&id=83586410&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83586410",
  null
  
)

export default component.exports